export enum GateHealthCheckStatus {
  Ok,
  Slow,
  ConnectionLost,
}
